import { useState } from 'react'
import { request } from 'hooks/useApi'

export default function useSyntheticVoice() {
  const [syntheticVoiceState, setState] = useState({
    isLoading: false,
  });
  
  const scriptToVoice = async (voiceId, text) => {
    setState({
      isLoading: true,
    });

    const result = await request('/rest/v2/syntheticvoice/script-to-voice', {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          voiceId,
          text
        }),
      },
    });

    setState({
      isLoading: false,
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    return result['data']['url'];
  }

  return [syntheticVoiceState, scriptToVoice]
}
